import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const insightsHubPlugin = createPlugin({
  id: 'insights-hub',
  apis: [],
  routes: {
    root: rootRouteRef,
  },
});

export const InsightsHubLandingPage = insightsHubPlugin.provide(
  createRoutableExtension({
    name: 'InsightsHubLandingPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
